module.exports = __webpack_public_path__ + "img/couples-047.e4e6ce20.jpg";